// extracted by mini-css-extract-plugin
export default {"root":"Badge_root__s-OrT","noBg":"Badge_noBg__jrpiM"};